import React from 'react';
export function UrgencyBanner() {
  const items = Array.from({
    length: 8
  });
  return <div className="sticky top-0 z-50 bg-[#A9D7E2] text-[#2D1F1A] py-3 shadow-md overflow-hidden" data-id="element-187">
      <div className="relative flex" data-id="element-188">
        <div className="flex shrink-0 animate-marquee whitespace-nowrap" data-id="element-189">
          {items.map((_, i) => <span key={`a-${i}`} className="mx-8 text-sm md:text-base font-bold inline-flex items-center gap-3" data-id="element-190">
              <span data-id="element-191">🎉 SOLO POR HOY + 3 CURSOS GRATIS</span>
              <span className="bg-[#F9A8B7] text-white px-3 py-0.5 rounded-full font-bold" data-id="element-192">
                SOLO POR $14.99
              </span>
              <span aria-hidden="true" className="text-[#F9A8B7]" data-id="element-193">
                ★
              </span>
            </span>)}
        </div>
        <div className="flex shrink-0 animate-marquee whitespace-nowrap" aria-hidden="true" data-id="element-194">
          {items.map((_, i) => <span key={`b-${i}`} className="mx-8 text-sm md:text-base font-bold inline-flex items-center gap-3" data-id="element-195">
              <span data-id="element-196">🎉 SOLO POR HOY + 3 CURSOS GRATIS</span>
              <span className="bg-[#F9A8B7] text-white px-3 py-0.5 rounded-full font-bold" data-id="element-197">
                SOLO POR $14.99
              </span>
              <span className="text-[#F9A8B7]" data-id="element-198">★</span>
            </span>)}
        </div>
      </div>
    </div>;
}